<template>
  <div id="login">
    <h1 class="system_name">广州市金界电子后台管理系统</h1>
    <div class="login_from_box">
      <div class="login_from">
        <h1 class="login_title">登录</h1>
        <form>
          <div style="margin:15px 0">
            <el-input v-model="user" placeholder="账号" prefix-icon="el-icon-s-custom"></el-input>
          </div>
          <div style="margin:15px 0">
            <el-input
              v-model="pass"
              type="password"
              placeholder="密码"
              show-password
              prefix-icon="el-icon-lock"
            ></el-input>
          </div>
          <div style="text-align:center;">
            <button type="button" v-on:click="login" style="width:310px;height:40px;">登录</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<style scoped>
#login {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login_title {
  text-align: center;
  padding-bottom: 15px;
}
.login_from_box {
  width: 350px;
  height: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -200px 0 0 -175px;
  border-radius: 3px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.login_from {
  padding: 20px 20px;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  background: #fff;
}
.system_name {
  margin-top: 60px;
}
</style>
<script>
export default {
  name: "login",
  data() {
    return {
      user: null,
      pass: null
    };
  },
  methods: {
    login() {
      var self = this;
      this.ajax(
        "/login_system.php?user=" + this.user + "&password=" + this.pass,
        "post",
        null,
        function(data) {
          var data = JSON.parse(data);
          if (data.status) {
            /** 为true 就跳转止 /admin 后台地址 */
            self.$router.push("/admin");

            /** 设置存放在vuex里面的token值，不设置不导致刷新需要重新登录后台 */
            self.$store.commit("addToken", {
              token: data.token
            });
          } else {
            self.$message.error("登录失败，账号或密码错误！");
          }
        }
      );
    }
  },
  created() {
    const self = this;
    this.$emit("public_header", false);
    this.$emit("public_nav", false);
    this.$emit("public_footer", false);
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key === 13) {
        self.login();
      }
    };
  }
};
</script>








// WEBPACK FOOTER //
// src/components/login.vue